import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsCycleTimeClassicBoardRoute: InvariantJiraRoute = {
	name: 'software-reports-cycle-time-classic-board',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/cycle-time',
	exact: true,
};
